import { Row } from "antd";
import React from "react";
import Container from "../../common/Container";
import { SvgIcon } from "../../common/SvgIcon";
import SiteConfig from "../../content/SiteConfig.json";
import { FooterProps } from "./types";

import { Extra, FooterContainer } from "./styles";

interface SocialLinkProps {
	href: string;
	src: string;
	label?: string;
}

const Footer: React.FC<FooterProps> = () => {
	const socialLinks = Array.isArray(SiteConfig.socialLinks)
		? SiteConfig.socialLinks.filter((link) => Boolean(link?.href))
		: [];

	const SocialLink = ({ href, src, label }: SocialLinkProps) => {
		// Fall back to the filename so a link added without a label still has one.
		const name = label ?? src;

		return (
			<a
				href={href}
				target="_blank"
				rel="noopener noreferrer"
				key={src}
				aria-label={name}
			>
				<SvgIcon src={src} width="25px" height="25px" alt={name} />
			</a>
		);
	};

	return (
		<>
			{/* 			<FooterSection>
				<Container>
					<Row justify="space-between">
						<Col lg={10} md={10} sm={12} xs={12}>
							<Language>Contact</Language>
							<Large to="/">Tell us everything</Large>
							<Para>
								Do you have any question? Feel free to reach
								out.
							</Para>
							<a href={`mailto:${contactEmail}`}>
								<Chat>Let's Chat</Chat>
							</a>
						</Col>
						<Col lg={8} md={8} sm={12} xs={12}>
							<Title>Policy</Title>
							<Large to="/">Application Security</Large>
							<Large to="/">Software Principles</Large>
						</Col>
						<Col lg={6} md={6} sm={12} xs={12}>
							<Empty />
							<Large to="/">Support Center</Large>
							<Large to="/">Customer Support</Large>
						</Col>
					</Row>
					<Row justify="space-between">
						<Col lg={10} md={10} sm={12} xs={12}>
							<Empty />
							<Language>Address</Language>
							{addressLines.map((line) => (
								<Para key={line}>{line}</Para>
							))}
						</Col>
						<Col lg={8} md={8} sm={12} xs={12}>
							<Title>Company</Title>
							<Large to="/">About</Large>
							<Large to="/">Blog</Large>
							<Large to="/">Press</Large>
							<Large to="/">Careers & Culture</Large>
						</Col>
					</Row>
				</Container>
			</FooterSection> */}
			<Extra>
				<Container border={true}>
					<Row
						justify="space-between"
						align="middle"
						style={{ paddingTop: "3rem" }}
					>
						<FooterContainer>
							{socialLinks.map((link) => (
								<SocialLink
									key={link.src}
									href={link.href}
									src={link.src}
									label={link.label}
								/>
							))}
						</FooterContainer>
					</Row>
				</Container>
			</Extra>
		</>
	);
};

export default Footer;
